
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";

@Options({
  name: "Image",
  props: {
    src: {
      type: String,
    },
    alt: {
      type: String as PropType<string>,
    },
    global: {
      type: Boolean,
      default: true,
    },
    d3model: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    getPath(val) {
      this.imagePath = val;
    },
  },
})
export default class Image extends Vue {
  private basePath = process.env.VUE_APP_RESOURCE_URL;
  private src!: string;
  private global!: boolean;
  private d3model!: boolean;
  private isLoaded = false;
  private isError = false;
  private imgPath = "";

  private get getPath(): string {
    if (this.global) {
      if (this.isError || !this.src) {
        return require(`@/assets/images/icons/broken-image.svg`);
      }

      if (this.d3model) {
        return `${process.env.VUE_APP_WEB_VIEWER_CONTENT_URL}${this.src}.preview.png`;
      }

      return `${this.basePath}/${this.src}`;
    }

    try {
      return require(`@/assets/images/${this.src}`);
    } catch (e) {
      return require(`@/assets/images/icons/broken-image.svg`);
    }
  }

  private get imagePath(): string {
    return this.imgPath;
  }

  private set imagePath(str: string) {
    this.imgPath = str;
  }

  private onImageLoad(): void {
    this.isLoaded = true;
  }

  private onImageLoadError(): void {
    this.isError = true;
  }

  mounted(): void {
    this.imagePath = this.getPath;
  }
}
